<template>
    <j-page class="j-form-demo-layout">
        <div slot="table">
            <el-card shadow="hover">
                <label slot="header">限制input输入</label>
                <el-divider content-position="left">正数（包括6位小数点）</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/\D*(\d*)(\.?)(\d{0,6})\d*/,'$1$2$3').replace(/^\./g, '')" />
                <el-divider content-position="left">只能输入正负数，不包括小数点</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[^\d\-]/g, '').replace(/\-{2,}/g, '-')" />
                <el-divider content-position="left">只能输入正数，不包括小数点</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[^\d]/g, '')" />
                <el-divider content-position="left">只能输入字母或数字</el-divider>
                <el-input v-model="form.number" oninput="value = value.replace(/[\W]/g, '')" />
            </el-card>
            <el-card shadow="hover">
                <label slot="header">表单校验规则</label>
                <el-divider content-position="left">el-form</el-divider>
                <el-form :model="form" :rules="rules" ref="ruleForm" label-width="300px">
                    <el-form-item label="身份证号" prop="idCard"><el-input v-model="form.idCard" /></el-form-item>
                    <el-form-item label="手机号" prop="phone"><el-input v-model="form.phone" /></el-form-item>
                    <el-form-item label="联系方式（座机/移动电话/手机号）" prop="tel"><el-input v-model="form.tel" /></el-form-item>
                    <el-form-item label="年龄" prop="age"><el-input v-model.number="form.age" oninput="value = value.replace(/[^\d]/g, '')" /></el-form-item>
                    <el-form-item label="电子邮件" prop="email"><el-input v-model="form.email" /></el-form-item>
                    <el-form-item label="密码" prop="pwd"><el-input v-model="form.pwd" /></el-form-item>
                    <el-form-item label="重复密码" prop="rePwd"><el-input v-model="form.rePwd" /></el-form-item>
                    <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                </el-form>
            </el-card>
        </div>
    </j-page>
</template>

<script>
    import ValidatorMixins from "../../components/JComponents/JPage/mixins/ValidatorMixins";
    import PageMixins from "../../components/JComponents/JPage/mixins/PageMixins";
    export default {
        name: "JFormDemo",
        mixins: [ValidatorMixins, PageMixins],
        data () {
            return {
               form: {
                   number: '',
                   idCard: '',
                   phone: '',
                   email: '',
                   tel: '',
                   age: '',
                   pwd: '',
                   rePwd: ''
               },
               rules: {
                   idCard: { required: true, validator: this.idCardValidator, trigger: ['blur', 'change'] },
                   phone: { required: true, validator: this.phoneValidator, trigger: ['blur', 'change'] },
                   email: { required: true, validator: this.emailValidator, trigger: ['blur', 'change'] },
                   tel: { required: true, validator: this.telValidator, trigger: ['blur', 'change'] },
                   pwd: { required: true, message: '请输入密码', trigger: ['blur', 'change'] },
                   rePwd: { required: true, validator: this.passValidator, trigger: ['blur', 'change'] },
                   age: { required: true, validator: this.ageValidator, trigger: ['blur', 'change'] }
               }
            }
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        alert('submit!');
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss">
    .j-form-demo-layout {
        position: relative;
        height: 100%;
        .el-card {
            position: relative;
            margin-bottom: 50px;
        }
        .result {
            color: #409EFF;
        }
    }
</style>
